'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$Id() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$Id as $c_Lapp_api_DrugRequestsAcceptedListItem$Id };
$c_Lapp_api_DrugRequestsAcceptedListItem$Id.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$Id.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$Id;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$Id() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$Id as $h_Lapp_api_DrugRequestsAcceptedListItem$Id };
$h_Lapp_api_DrugRequestsAcceptedListItem$Id.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$Id.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$Id.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id.prototype.$eq$eq__Ljkugiya_ulid_ULID__Z = (function(id) {
  if ((this instanceof $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest)) {
    var x86 = this.Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest__f_drugReqId;
    return ((x86 === null) ? (id === null) : x86.equals__O__Z(id));
  }
  if ((this instanceof $c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport)) {
    return false;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
function $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$Id(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_DrugRequestsAcceptedListItem$Id)));
}
export { $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$Id as $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$Id };
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest(drugReqId) {
  this.Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest__f_drugReqId = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest__f_drugReqId = drugReqId;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest as $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest };
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest.prototype = new $h_Lapp_api_DrugRequestsAcceptedListItem$Id();
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest as $h_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest };
$h_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 675570861, true);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest)) {
    var x = this.Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest__f_drugReqId;
    var x$2 = x$0.Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest__f_drugReqId;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest.prototype.productPrefix__T = (function() {
  return "DrugRequest";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest__f_drugReqId;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "drugReqId";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest.prototype.ordinal__I = (function() {
  return 0;
});
function $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest)));
}
export { $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest as $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest };
var $d_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest, "app.api.DrugRequestsAcceptedListItem$Id$DrugRequest", ({
  Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest: 1,
  Lapp_api_DrugRequestsAcceptedListItem$Id: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest as $d_Lapp_api_DrugRequestsAcceptedListItem$Id$DrugRequest };
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport(reportId) {
  this.Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport__f_reportId = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport__f_reportId = reportId;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport as $c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport };
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport.prototype = new $h_Lapp_api_DrugRequestsAcceptedListItem$Id();
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport as $h_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport };
$h_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1778330084), true);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport)) {
    var x = this.Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport__f_reportId;
    var x$2 = x$0.Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport__f_reportId;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport.prototype.productPrefix__T = (function() {
  return "OutOfStockMedicationReport";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport__f_reportId;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "reportId";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport)));
}
export { $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport as $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport };
var $d_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport, "app.api.DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport", ({
  Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport: 1,
  Lapp_api_DrugRequestsAcceptedListItem$Id: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport as $d_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$-Id.js.map
